var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarCircle = function SvgDollarCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H10.0866V11.0639L11.6186 9H12.9125L10.939 11.6757L13.1045 15H11.8298L10.0866 12.3365V15H9V9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5077 10.5622H14.4061V11.121C14.5034 10.9007 14.6327 10.7335 14.7939 10.6193C14.9552 10.5051 15.1318 10.448 15.3238 10.448C15.4595 10.448 15.6015 10.4861 15.75 10.5622L15.4236 11.5207C15.3008 11.4555 15.1997 11.4228 15.1203 11.4228C14.959 11.4228 14.8221 11.5289 14.7095 11.741C14.5994 11.9531 14.5444 12.3691 14.5444 12.9891L14.5482 13.2053V15H13.5077V10.5622Z"
  })));
};
export default SvgDollarCircle;